<template>
  <div
    :class="wrapperClass"
    class="basic-accordion"
  >
    <accordion-item
      v-for="(accordion, index) of accordionsWithContent"
      :key="`${accordion.title}-${index}`"
      :index="index"
      :active="activeIndex === index"
      :title="accordion.title"
      :heading-level="2"
      @toggle-accordion="toggleAccordion"
    >
      <template #content>
        <div v-html="accordion.content" />
      </template>
    </accordion-item>
  </div>
</template>

<script>

/**
 * Vue: Basic accordion (basic-accordion)
 * -----------------------------------------------------------------------------
 * Accordion item that allows for a title and html to be passed in.
 *
 * @param {{title: String, content: String}[]} [accordionItems] - An array of
 * accordion items.
 * @param {String} [wrapperClass] - A class that is applied to the wrapper.
 *
 */
import AccordionItem from '~async/basic-accordion/accordion-item'

export default {
  name: 'BasicAccordion',

  components: {
    AccordionItem,
  },

  props: {
    initialActiveIndex: {
      type: [Boolean, Number],
      default: -1,
    },
    accordionItems: {
      type: Array,
      default: () => [],
    },
    wrapperClass: {
      type: String,
      default: '',
    },
  },

  data() {
    return {
      activeIndex: this.initialActiveIndex,
    }
  },

  computed: {

    /**
     * Compute non-empty accordion items
     * @returns {[]}
     */
    accordionsWithContent() {
      return this.accordionItems.filter((item) => item.content)
    },
  },

  watch: {

    /**
     * Update active index when prop changes
     * @param newVal
     */
    initialActiveIndex(newVal) {
      this.activeIndex = newVal
    },
  },

  methods: {

    /**
     * Toggle accordion's active state.
     * @param {Number} index - ID of accordion.
     */
    toggleAccordion(index) {
      this.activeIndex = this.activeIndex === index ? -1 : index
    },
  },
}
</script>
